var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useSiteMetadata } from "./use-site-metadata";
import { pickBy } from 'lodash';
import { useSite } from "./use-site";
export var useSocialLinks = function (urls) {
  var site = useSite();
  var siteMetadata = useSiteMetadata();
  return pickBy(__assign({
    twitter: site.twitter || siteMetadata.twitter,
    threads: site.threads || siteMetadata.threads,
    facebook: site.facebook || siteMetadata.facebook,
    linkedin: site.linkedin || siteMetadata.linkedin,
    instagram: site.instagram || siteMetadata.instagram,
    flickr: site.flickr || siteMetadata.flickr,
    tiktok: site.tiktok || siteMetadata.tiktok,
    youtube: site.youtube || siteMetadata.youtube
  }, urls));
};